import uuidv4 from 'uuid/v4';
import { IInvitationCodeGenerator } from './IInvitationCodeGenerator';

export class InvitationCodeGenerator implements IInvitationCodeGenerator {
  public generate(): string {
    return uuidv4();
  }
}
